import ResetPasswordForm from "./ResetPasswordForm";
import { useParams } from "react-router-dom";
const ResetPassword = () => {
  const { token } = useParams();
  // console.log(token);
  return <ResetPasswordForm token={token} />;
};

export default ResetPassword;
